import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useLocationChanged = (action) => {
  const location = useLocation();

  const handler = useCallback(() => {
    action(location);
  }, [action, location]);

  useEffect(() => {
    handler();
  }, [handler]);
};

export default useLocationChanged;
